import { hotScoops } from "@/mocks/kanliao";

export default function Scoops() {
  const [big, ...rest] = hotScoops;
  return (
    <section id="scoop" className="bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold tracking-widest text-primary-600">
              <i className="ri-megaphone-fill" />
              SCOOP · 爆料
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              5看料最新爆料，先睹为快
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              图文并重喂饱你，每条都有来处、有时间、有热评。蹲更新就认准这里。
            </p>
          </div>
          <div className="flex items-center gap-1 rounded-full bg-background-100 p-1">
            {["综合", "恋情", "剧综", "音乐"].map((t, i) => (
              <button
                key={t}
                type="button"
                className={
                  "cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-xs font-medium transition-colors " +
                  (i === 0
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:bg-background-200")
                }
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-[1.5fr_1fr]">
          <article className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100/70 transition-transform duration-300 hover:-translate-y-1 lg:flex-row">
            <div className="relative h-56 w-full overflow-hidden lg:h-auto lg:w-[46%]">
              <img
                src={big.image}
                alt={big.title}
                title={big.title}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 flex items-center gap-1 rounded-md bg-primary-500 px-2 py-1 text-[11px] font-black text-background-50">
                头条爆料
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5">
              <div className="flex items-center gap-2">
                <span className="rounded-full bg-primary-100 px-2.5 py-0.5 text-[11px] font-semibold text-primary-700">
                  {big.tag}
                </span>
                <span className="text-[11px] text-foreground-500">{big.minutes}</span>
              </div>
              <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 lg:text-2xl">
                {big.title}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{big.sub}</p>
              <div className="mt-4 flex items-center gap-4 text-[12px] text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-chat-3-fill text-primary-500" />
                  {big.comment.toLocaleString()} 蹲评
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-fire-fill text-accent-600" />
                  #{big.rank} 热度
                </span>
              </div>
            </div>
          </article>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-1">
            {rest.map((s) => (
              <article
                key={s.title}
                className="group flex cursor-pointer gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-all hover:-translate-y-0.5 hover:border-primary-200"
              >
                <div className="h-20 w-24 shrink-0 overflow-hidden rounded-md sm:w-28">
                  <img
                    src={s.image}
                    alt={s.title}
                    title={s.title}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="flex min-w-0 flex-1 flex-col">
                  <div className="flex items-center gap-1.5">
                    <span className="rounded-full bg-background-200 px-2 py-0.5 text-[10px] font-semibold text-foreground-700">
                      {s.tag}
                    </span>
                    <span className="truncate text-[11px] text-foreground-400">{s.minutes}</span>
                  </div>
                  <h3 className="mt-1.5 line-clamp-2 text-[13px] font-semibold leading-snug text-foreground-950">
                    {s.title}
                  </h3>
                  <p className="mt-auto pt-1 text-[11px] text-foreground-500">
                    <i className="ri-fire-fill mr-1 text-accent-600" />
                    {s.comment.toLocaleString()} 蹲评
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}